import { MockedPaymentApi } from "./mockedpaymentapi";
import { MockedWebClient } from "./mockedwebclient";

export const mockedWebClient = new MockedWebClient();
export const mockedPaymentApi = new MockedPaymentApi(mockedWebClient);
